import { render, staticRenderFns } from "./info-detail.vue?vue&type=template&id=6033adea&scoped=true&"
import script from "./info-detail.vue?vue&type=script&lang=js&"
export * from "./info-detail.vue?vue&type=script&lang=js&"
import style0 from "./info-detail.vue?vue&type=style&index=0&id=6033adea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6033adea",
  null
  
)

export default component.exports